import { render, staticRenderFns } from "./AddComment.vue?vue&type=template&id=51a17178&"
import script from "./AddComment.vue?vue&type=script&lang=js&"
export * from "./AddComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51a17178')) {
      api.createRecord('51a17178', component.options)
    } else {
      api.reload('51a17178', component.options)
    }
    module.hot.accept("./AddComment.vue?vue&type=template&id=51a17178&", function () {
      api.rerender('51a17178', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/support/AddComment.vue"
export default component.exports